<template>
    <div class="body" v-title data-title="登录">
        <img class="login_img" src="../assets/images/login_backimg.png" alt="" srcset="">
        <div class="login_form_div">
            <img class="logo-img" src="../assets/images/未标题-1.png" alt="" srcset="">
            <div class="login_form_title">数控加工工艺与装备教学平台</div>
            <div class="welcome-title">欢迎登录</div>
            <div class="welcome-english">Please Log in</div>
                <el-form ref="form" :model="form" :rules="rules" label-position="left">
                        <el-form-item prop="username">
                            <el-input v-model.trim="form.username" placeholder="请输入用户名" tabindex="1" type="text"
                                prefix-icon="el-icon-user">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input :key="passwordType" autocomplete="new-password" ref="password"
                                v-model.trim="form.password" :type="passwordType" tabindex="2" placeholder="请输入密码"
                                prefix-icon="el-icon-view">
                            </el-input>
                        </el-form-item>
                        <el-button type="primary" class="login_button" @click.prevent="doLogin">登录</el-button>
                </el-form>
            </div>
        
    </div>

</template>

<script>
export default {
    data() {
        const validateusername = (rule, value, callback) => {
            if ('' == value) {
                callback(new Error('用户名不能为空'))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if ('' == value) {
                callback(new Error('密码不能为空'))
            } else {
                callback()
            }
        }
        return {
            form: {
                username: '',
                password: '',
            },
            rules: {
                username: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validateusername,
                    },
                ],
                password: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validatePassword,
                    },
                ],
            },
            passwordType: 'password',
        }
    },
    methods: {
        doLogin() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$axios.post(this.$global.basUrl + 'api/demo/public/doStuLogin', this.form).then(res => {
                        var data = res.data
                        if (data.code == 1) {
                            sessionStorage.setItem('personId', res.data.data.id)
                            sessionStorage.setItem('user_nickname', res.data.data.user_nickname)

                            this.$router.push({
                                name: 'Index'
                            })
                        } else {
                            this.statusPd(data)
                        }
                    })

                }
            })
        }
    }
}
</script>

<style scoped>
.body {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0px;
    display: flex;
}
.login_img{
    width: 50%;
}
.login_form_div{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 70px auto;

}
.logo-img{
    width: 180px;
    height: 45px;
}
.login_form_title{
    margin: 30px 0 70px;
    color: #0010B4;
    font-size: 60px;
    font-weight: 600;
}
.welcome-title{
    color: #414BDE;
    font-size: 30px;
    font-weight: 600;
}
.welcome-english{
    color: #C3C3C3;
    font-size: 20px;
    margin-bottom: 30px;
}
.login_button {
    margin-top: 50px;
    width: 360px;
    background: #454EDF;
    border: solid 1px #454EDF;
}
</style>